import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Configuration } from "../_types/configuration";

@Injectable({
    providedIn: 'root',
})
export class ConfigurationsService extends Service<Configuration> {
    public override type = 'configurations';
    public override url = 'common/configurations';
}
